var _filter, _filter2, _filter3, _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmptyFollows = function SvgEmptyFollows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 542 336"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "empty-follows_svg__a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 112,
    width: 400,
    x: 0,
    y: 16
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "empty-follows_svg__b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 112,
    width: 400,
    x: 142,
    y: 120
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "empty-follows_svg__c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 112,
    width: 400,
    x: 0,
    y: 224
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#c2c9d1",
    height: 336,
    rx: 60,
    width: 350,
    x: 96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.9,
    height: 336,
    rx: 60,
    width: 350,
    x: 96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-follows_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 24h368v80H16z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h55v60H26z",
    fill: "#f4af3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h55v60H26z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46H44c-2.2 0-3.98 1.8-3.98 4L40 82l14-6 14 6V50c0-2.2-1.8-4-4-4z",
    fill: "#f4af3d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 54h267v19H90z",
    fill: "#c2c9d1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 54h267v19H90z",
    fill: "#fff",
    fillOpacity: 0.75
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-follows_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 128h368v80H158z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 138h55v60h-55z",
    fill: "#003049"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168 138h55v60h-55z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206 150h-20c-2.2 0-3.98 1.8-3.98 4l-.02 32 14-6 14 6v-32c0-2.2-1.8-4-4-4z",
    fill: "#003049"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232 158h267v19H232z",
    fill: "#c2c9d1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232 158h267v19H232z",
    fill: "#fff",
    fillOpacity: 0.75
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-follows_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 232h368v80H16z",
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26 242h55v60H26z",
    fill: "#f03738"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 242h55v60H26z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64 254H44c-2.2 0-3.98 1.8-3.98 4L40 290l14-6 14 6v-32c0-2.2-1.8-4-4-4z",
    fill: "#db5437"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 262h267v19H90z",
    fill: "#c2c9d1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90 262h267v19H90z",
    fill: "#fff",
    fillOpacity: 0.75
  })));
};
export default SvgEmptyFollows;